<div class="mainContainer">
    <div class="tittleContainer">
        <p class="title">Camera Container</p>
        <figure>
            <img src="../../../assets/image/baseline-close.svg" alt="" (click)="buttonClose()">
        </figure>
    </div>
    <div class="dataContainer">
      <label for="input" class="text">Camera Location Name</label>
      <input type="text" id="input" class="input" (input)="getChannelName($event)">
    </div>
    <div class="buttonContainer">
       <button class="closeButton" (click)="buttonClose()">close</button>
       <button class="submitButton" (click)="buttonClose()">submit</button>
    </div>
</div>